import React from "react";
import { useState } from "react";
import Dropdown from "./Dropdown";
import Plot from "react-plotly.js";


const Heatmap = ({corr_data, corr_features, null_data}) => {
// console.log("heatmap _ ",data)
  const heatmap_attriutes = [
    { value: "correlation", label: "Correlation Heatmap" },
    { value: "null_value", label: "Null Value Heatmap" },
  ];
  const initheatmap = heatmap_attriutes[0].value;
  const [heatAttribute, setheatAttributes] = useState(initheatmap);

  var heatplot;

  if (heatAttribute === 'null_value'){
    var yind = []
    null_data.map((d,i)=>(yind.push(i)))
    heatplot = [{
        z: null_data,
        x: corr_features,
        y: yind,
        type:"heatmap",
        hoverongaps:false
    
      }];

  }else{
    heatplot = [{
        z: corr_data,
        x: corr_features,
        y: corr_features,
        type:"heatmap",
        hoverongaps:false,
        showscale: false
    
      }];
  }
 var layout = {
  width: 900, height: 500, title: 'Heatmap Plot',
        annotations: [],
        xaxis: {
          ticks: '',
        },
        yaxis: {
          ticks: '',
          ticksuffix: ' ',
          width: 700,
          height: 700,
          autosize: true
        }
 }

 for ( var i = 0; i < corr_features.length; i++ ) {
  for ( var j = 0; j < corr_features.length; j++ ) {
    var currentValue = corr_data[i][j];
    if (currentValue !== 0.0) {
      var textColor = 'white';
    }else{
      var textColor = 'black';
    }
    var result = {
      xref: 'x1',
      yref: 'y1',
      x: corr_features[j],
      y: corr_features[i],
      text: Math.round(corr_data[i][j] * 100)/100,
      font: {
        family: 'Arial',
        size: 12,
        color: 'rgb(50, 171, 96)'
      },
      showarrow: false,
      font: {
        color: textColor
      }
    };
    layout.annotations.push(result);
  }
}



  return (
    <>
      <div className="col-3">
        {/* <h4>Select heatmap:</h4> */}
        <Dropdown
          options={heatmap_attriutes}
          id="heatmap"
          selectedValue={heatAttribute}
          onSelectedValueChange={setheatAttributes}
        />
      </div>
      <div className="col-9">
        <Plot data= {heatplot} 
        layout={layout}
        />
      </div>
    </>
  );
};

export default Heatmap;
